// extracted by mini-css-extract-plugin
export var wrapper = "style-module--wrapper--zl3Qh";
export var container = "style-module--container--y7DgI";
export var labelWrapper = "style-module--labelWrapper--yvAWO";
export var small = "style-module--small--v69DI";
export var labelText = "style-module--labelText--y-7tE";
export var input = "style-module--input--xeMr2";